<template>
  <div class="sidebar py-4 px-3" :class="{'collapsed':collapsed}">
      <div id="sidebar-menus" v-if="initialized">
        <SideBarMenu>
          <template v-slot:header>Root note</template>
          <template v-slot:items>
            <SideBarMenuItem @click="goToNote(rootNote.id, null, $event, { toggleSideBar: windowIsMobile })">
              <router-link :to="{ name: 'noteByContextion', params: { contextion: getContextion(rootNote.id) } }" class="d-flex align-items-center">
                <i class="fas fa-fw fa-home mr-1" />
                {{rootNote.title.substr(0, 20)}}
              </router-link>
            </SideBarMenuItem>
          </template>
        </SideBarMenu>
        <SideBarMenu v-if="activeViewMode">
          <template v-slot:header>View mode</template>
          <template v-slot:items>
            <SideBarMenuItem :active="activeViewMode.name===mode.name" v-for="mode in viewModes" :key="mode.name" @click="setViewMode(mode)">
              <i :class="`fas fa-${mode.icon} fa-fw mr-1`"></i>
              {{viewModeName(mode.name)}}
            </SideBarMenuItem>
          </template>
        </SideBarMenu>
        <!-- <SideBarMenu v-if="links.to.length>0">
          <template v-slot:header>
            <i class="fas fa-fw fa-sign-in-alt mr-1"></i> Links to
          </template>
          <template v-slot:items>
            <SideBarMenuItem v-for="note in links.to" :key="note.id" @click="goToNote(note.id, null, $event, { toggleSideBar: windowIsMobile })">
              <router-link :to="{ name: 'noteByContextion', params: { contextion: getContextion(note.id) } }" class="d-flex align-items-center">
                <i class="far fa-file-alt fa-fw mr-1" />
                {{note.title.substr(0, 20)}}
                <span class="badge badge-secondary ml-auto" v-if="note.count>1">{{ note.count }}</span>
              </router-link>
            </SideBarMenuItem>
          </template>
        </SideBarMenu>
        <SideBarMenu v-if="links.from.length>0">
          <template v-slot:header>
            <i class="fas fa-fw fa-sign-out-alt mr-1"></i> Linked from
          </template>
          <template v-slot:items>
            <SideBarMenuItem v-for="note in links.from" :key="note.id" @click="goToNote(note.id, null, $event, { toggleSideBar: windowIsMobile })">
              <router-link :to="{ name: 'noteByContextion', params: { contextion: getContextion(note.id) } }" class="d-flex align-items-center">
                <i class="far fa-file-alt fa-fw mr-1" />
                {{note.title.substr(0, 20)}}
                <span class="badge badge-secondary ml-auto" v-if="note.count>1">{{ note.count }}</span>
              </router-link>
            </SideBarMenuItem>
          </template>
        </SideBarMenu> -->
        <SideBarMenu v-if="recentNotes.length>0">
          <template v-slot:header>
            <i class="far fa-fw fa-clock mr-1"></i> Recent notes
          </template>
          <template v-slot:items>
            <SideBarMenuItem v-for="note in recentNotes" :key="note.id" @click="goToNote(note.id, null, $event, { toggleSideBar: windowIsMobile })">
              <router-link :to="{ name: 'noteByContextion', params: { contextion: getContextion(note.id) } }">
                <i class="far fa-file-alt fa-fw mr-1" />
                {{note.title.substr(0, 20)}}
              </router-link>
            </SideBarMenuItem>
          </template>
        </SideBarMenu>
        <SideBarMenu v-if="similarNotes.length>0">
          <template v-slot:header>
            <i class="fas fa-fw fa-lightbulb mr-1"></i> Similar notes
          </template>
          <template v-slot:items>
            <SideBarMenuItem v-for="note in similarNotes" :key="note.id" @click="goToNote(note.id, null, $event, { toggleSideBar: windowIsMobile })">
              <router-link :to="{ name: 'noteByContextion', params: { contextion: getContextion(note.id) } }">
                <i class="far fa-file-alt fa-fw mr-1" />
                {{note.title.substr(0, 20)}}
              </router-link>
            </SideBarMenuItem>
          </template>
        </SideBarMenu>
      </div>
  </div>
</template>
<script>
import stringSimilarity from 'string-similarity'
import SideBarMenu from '@/components/SideBar/SideBarMenu'
import SideBarMenuItem from '@/components/SideBar/SideBarMenuItem'
import goToNote from '@/mixins/go-to-note'
import { mapState } from 'vuex'
import variables from '@/assets/_variables.scss'

export default {
  props: ['collapsed', 'windowWidth'],
  components: {
    SideBarMenu,
    SideBarMenuItem
  },
  mixins: [goToNote],
  computed: {
    initialized() {
      return this.$store.state.initialized
    },
    rootNote() {
      return this.$store.getters.rootNote
    },
    similarNotes() {
      const notes = this.$store.getters.notes.slice().sort((a, b) => b.modified - a.modified)
      const currentNote = this.$store.getters.currentNote
      if (currentNote) {
        const similarNotes = notes
          .map(note => {
            const similarity = stringSimilarity.compareTwoStrings(note.title.toLowerCase(), currentNote.title.toLowerCase())
            return { ...note, similarity }
          }).filter(note => note.similarity > 0.3 && note.id !== currentNote.id)
          .sort((a, b) => b.similarity - a.similarity)
        return similarNotes.slice(0, 3)
      } else {
        return []
      }
    },
    // links() {
    //   return this.$store.getters.links
    // },
    recentNotes() {
      return this.$store.getters.notes.slice().sort((a, b) => b.modified - a.modified).slice(0, 3)
    },
    windowIsMobile() {
      const breakpoint = parseInt(variables.sidebarCollapse.replace('px', ''))
      return this.windowWidth < breakpoint
    },
    promptForPassphrase() {
      return this.$store.getters['encryption/promptForPassphrase']
    },
    ...mapState(['viewModes', 'activeViewMode'])
  },
  methods: {
    async addNote() {
      const newNote = await this.$store.dispatch('addNote', { title: 'Untitled note' })
      this.goToNote(newNote.id)
    },
    setViewMode(mode) {
      this.$store.dispatch('setViewMode', mode)
      if (this.windowIsMobile) this.$emit('toggle-collapse')
    },
    viewModeName(modeName) {
      return modeName.charAt(0).toUpperCase() + modeName.slice(1)
    }
  }
}
</script>
<style scoped lang="scss">
@import "~bootstrap/scss/_functions";
@import "~bootstrap/scss/_variables";
@import "~bootstrap/scss/mixins";
a,
a:hover {
  display: block;
  width: 100%;
  color: inherit !important;
  text-decoration: none;
}
.collapse-sidebar {
  line-height: 1.2rem;
}
.sidebar {
  background-color: $app-background-color;
  display: block;
  position: fixed;
  top: $topbar-height;
  bottom: 0;
  width: map-get($sidebar-width, expanded);
  overflow-y: auto;
  color: $gray-600;
  // transition: all 0.3s;
}
@include media-breakpoint-down(xs) {
  .sidebar {
    left: 0;
    width: 100%;
    z-index: 10;
  }
  .collapsed {
    display: none;
  }
  .sidebar .sidebar-menu {
    font-size: 120% !important;
  }
}
.sidebar-menu--header {
  margin-top: 100px;
}
#sidebar-menus {
  /deep/ .sidebar-menu:first-child {
    padding-top: 0;
  }
  /deep/ .sidebar-menu:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }
  /deep/ .sidebar-menu {
    padding: $spacer*1.1 0;
    border-bottom: 1px solid $app-border-color;
  }
}
.add-note-button {
  min-width: 2rem;
}
</style>
